import React, { useState, useEffect } from 'react'
import '../CI/COD.css'
import { postRequest, getRequest } from '../../globalhelper/helper'
import VR2_Forms from '../../pages/VR2_Form_Rendering/displayContainer'
import Select from 'react-select'
import _ from 'lodash'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Paper } from '@material-ui/core'
import moment from 'moment'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { GetApp } from '@material-ui/icons'
import { CSVLink } from 'react-csv'

export default function GoodsAndServicesSearch(props) {
  const [tableData, setTableData] = useState([])
  const [displayData, setDisplayData] = useState([])
  const [formData, setFormData] = useState({
    document_number: '',
    vendor_id: '',
    vendor_name: '',
    document_type: '',
    orgname: '',
    period: null,
    invoiceRef: ''
  });
  const [redirect, setRedirect] = useState(false);
  const [searchJSON, setSearchJSON] = useState([]);
  const [dropdown, setDropdown] = useState({
    documentNumber: [],
    vendorID: [],
    vendorName: [],
    documentType: [],
    orgname: [],
    invoiceRef: []
  });
  const [companyDetails, setCompanyDetails] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`).then(response => {
      console.log(response.res.data);
      const responseData = _.sortBy(response.res.data, 'orgname');
      const arr = responseData.map(item => item.orgname)?.sort((a, b) => a.localeCompare(b));
      setDropdown(prevState => {
        return {
          ...prevState,
          orgname: arr
        };
      });
      setCompanyDetails(responseData);
    });
  }, []);
  useEffect(() => {
    if (dropdown.orgname.length === 1) {
      handleChange('orgname', dropdown.orgname[0]);
    }
  }, [companyDetails]);
  const getFilteredArray = (value, key) => {
    let dropdown_array = value.map(value => value[key]).filter(value => value !== null);
    let filtered_dropdown_array = [...new Set(dropdown_array)];
    return filtered_dropdown_array.filter(item => item !== undefined && item !== '');
  };
  const handleChange = (name, value) => {
    console.log(name, value);
    setFormData(prevState => {
      return {
        ...prevState,
        [name]: value || ''
      };
    });
    if (name === 'orgname' && value !== '') {
      handleRemainingAPIs(value);
    }
  };
  const handleSearch = () => {
    const {
      document_number,
      vendor_id,
      vendor_name,
      document_type,
      orgname
    } = formData;
    if (orgname) {
      setError(false);
      postRequest(`api/edureka/getGoodsAndServicesInfoSearch`, {
        documentNumber: document_number,
        vendorID: vendor_id,
        vendorName: vendor_name,
        documentType: document_type
      }).then(response => {
        console.log(JSON.parse(response.res.data));
        const data = JSON.parse(response.res.data);
        if (data && data.length) {
          let invoiceRef = getFilteredArray(data, 'Invoice Ref')?.sort((a, b) => a.toString().localeCompare(b.toString()));
          let linked_po = getFilteredArray(data, 'Linked PO')?.sort((a, b) => a.toString().localeCompare(b.toString()));
          setDropdown(prevState => {
            return {
              ...prevState,
              invoiceRef: invoiceRef,
              linked_po: linked_po
            };
          });
          setTableData(data);
          setDisplayData(data);
          setShowTable(true);
        } else {
          setError(true);
          setErrorMessage(<Box sx={{
            margin: 'auto'
          }}>
            <Alert severity='warning'>
              <AlertTitle>No Data Found</AlertTitle>
              There is no data to display at the moment.
            </Alert>
          </Box>);
        }
      });
    } else {
      setError(true);
      setErrorMessage(<Box sx={{
        margin: 'auto'
      }}>
        <Alert severity='warning'>
          <AlertTitle>Error Message</AlertTitle>
          Please select all the required fields
        </Alert>
      </Box>);
    }
  };
  const handleReset = () => {
    setFormData({
      document_number: '',
      vendor_id: '',
      vendor_name: '',
      document_type: '',
      orgname: '',
      period: null
    });
    setTableData([]);
    setShowTable(false);
    setError(false);
  };
  const handleJSON = item => {
    const documentNumber = item['GRN/SRN Number'];
    const id = companyDetails.filter(item => item.orgname === formData.orgname);
    const companyid = id.map(item => item.orgid);
    localStorage.setItem(
      'api',
      `api/edureka/getUpdatedDataFromDB`
    )
    localStorage.setItem('apiParams', JSON.stringify({
      "LDE": {
        "Receiver ID": companyid[0],
        "GRN/SRN Number": documentNumber,
      },
      "Module": localStorage.getItem('module'),
      "screenName": "GoodsAndServicesEntries"
    }))
    window.open(`/Dynamic_Forms?token=GoodsAndServicesEntries&action=edit&orgId=${companyid[0]}&docId=${documentNumber}`, '_blank');
    // postRequest(
    //   `api/edureka/getGoodsAndServicesInfoJSON?orgid=${companyid[0]}`,
    //   { documentNumber: documentNumber }
    // ).then(response => {
    //   console.log(response.res.data)
    //   if (response.res.status === 'success') {
    //     setSearchJSON(response.res.data)
    //     setRedirect(true)
    //   } else {
    //     console.log('No JSON exists')
    //   }
    // })
  };
  const onBack = () => {
    setRedirect(false);
    setSearchJSON([]);
  };
  const handleRemainingAPIs = value => {
    console.log(formData.orgname);
    const id = companyDetails.filter(item => item.orgname === value);
    const companyid = id.map(item => item.orgid);
    console.log('Entered');
    getRequest(`api/edureka/getGoodsAndServicesInfo?orgid=${companyid[0]}`).then(response => {
      const data = JSON.parse(response.res.data) ? JSON.parse(response.res.data) : [];
      let document_number = getFilteredArray(data, 'GRN')?.sort((a, b) => a.toString().localeCompare(b.toString()));
      let vendorid = getFilteredArray(data, 'Vendor ID')?.sort((a, b) => a.toString().localeCompare(b.toString()));
      let vendorname = getFilteredArray(data, 'Vendor Name')?.sort((a, b) => a.toString().localeCompare(b.toString()));
      let documenttype = getFilteredArray(data, 'Document Type')?.sort((a, b) => a.toString().localeCompare(b.toString()));
      setDropdown(prevState => {
        return {
          ...prevState,
          documentNumber: document_number,
          vendorID: vendorid,
          vendorName: vendorname,
          documentType: documenttype
        };
      });
    });
  };
  useEffect(() => {
    const startDate = moment(formData.period, 'YYYY-MM').startOf('month');
    const endDate = moment(formData.period, 'YYYY-MM').endOf('month');
    const filtered = tableData.filter(item => {
      const itemDate = moment(item?.['Invoice Date'], ['YYYY-MM-DDTHH:mm:ss.SSSZ', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD', 'DD/MM/YYYY'], true);
      return (formData.period === null || itemDate.isSameOrAfter(startDate) && itemDate.isSameOrBefore(endDate)) && (item['Invoice Ref'] === formData.invoiceRef || formData.invoiceRef === '' || formData.invoiceRef === undefined || formData.invoiceRef === null) && (item['Linked PO'] === formData.linked_po || formData.linked_po === '' || formData.linked_po === undefined || formData.linked_po === null);
    });
    console.log(filtered, formData);
    setDisplayData(filtered);
  }, [formData.period, formData.invoiceRef, formData.linked_po]);
  if (redirect) {
    return <VR2_Forms screenName={'GoodsAndServicesEntries'} screenAction={'edit'} From_SearchJSON={searchJSON} onBack={onBack} />;
  } else return <>
    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant='h6'>
          Search Goods and Services Entries
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container gap={2} spacing={3}>
          <Grid item xs={1} sm={2} md={3}>
            <Autocomplete fullwidth options={dropdown.orgname} value={formData.orgname} onChange={(e, newValue) => handleChange('orgname', newValue)} renderInput={params => <TextField {...params} label='Organization Name' variant='outlined' size='small' fullWidth />} />
          </Grid>
          <Grid item xs={1} sm={2} md={2}>
            <Autocomplete fullwidth options={dropdown.documentNumber} value={formData.document_number} onChange={(e, newValue) => handleChange('document_number', newValue)} renderInput={params => <TextField {...params} label='SRN/GRN Number' variant='outlined' size='small' fullWidth />} />
          </Grid>
          <Grid item xs={1} sm={2} md={2}>
            <Autocomplete fullwidth options={dropdown.vendorID} value={formData.vendor_id} onChange={(e, newValue) => handleChange('vendor_id', newValue)} renderInput={params => <TextField {...params} label='Vendor ID' variant='outlined' size='small' fullWidth />} />
          </Grid>
          <Grid item xs={1} sm={2} md={2}>
            <Autocomplete fullwidth options={dropdown.vendorName} value={formData.vendor_name} onChange={(e, newValue) => handleChange('vendor_name', newValue)} renderInput={params => <TextField {...params} label='Vendor Name' variant='outlined' size='small' fullWidth />} />
          </Grid>
          <Grid item xs={1} sm={2} md={2}>
            <Autocomplete fullwidth options={dropdown.documentType} value={formData.document_type} onChange={(e, newValue) => handleChange('document_type', newValue)} renderInput={params => <TextField {...params} label='Document Type' variant='outlined' size='small' fullWidth />} />
          </Grid>
        </Grid>
        <Grid container spacing={3} mt={2}>
          {tableData.length > 0 && <>
            <Grid item xs={1} sm={2} md={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker label='Period' value={formData.period} views={['month', 'year']} onChange={newValue => handleChange('period', newValue)} renderInput={params => <TextField fullWidth size='small' {...params} />} />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={1} sm={2} md={2}>
              <Autocomplete fullwidth options={dropdown.invoiceRef} value={formData.invoiceRef} onChange={(e, newValue) => handleChange('invoiceRef', newValue)} renderInput={params => <TextField {...params} label='Invoice Ref' variant='outlined' size='small' fullWidth />} />
            </Grid>
            <Grid item xs={1} sm={2} md={2}>
              <Autocomplete fullwidth options={dropdown.linked_po || []} value={formData.linked_po ?? null} onChange={(e, newValue) => handleChange('linked_po', newValue)} renderInput={params => <TextField {...params} label='Linked PO' variant='outlined' size='small' fullWidth />} />
            </Grid>
          </>}
          <Grid item>
            <Button variant='contained' color='success' onClick={handleSearch}>
              Search
            </Button>
            &nbsp;
            <Button variant='contained' color='error' style={{
              marginLeft: 10
            }} onClick={handleReset}>
              Reset
            </Button>
            &nbsp;
            <Button variant='contained' color='warning' style={{
              marginLeft: 10
            }} onClick={() => props.onBack()}>
              Back
            </Button>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>

    <br />

    {showTable && tableData.length ? <>
      <Box align='right'>
        <Button color='success' variant='contained'>
          <CSVLink style={{
            color: 'white',
            textDecoration: 'none'
          }} data={tableData} filename='GRN.csv'>
            <GetApp />
          </CSVLink>
        </Button>
      </Box>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell>GRN/SRN Number</TableCell>
              <TableCell>Linked PO Number</TableCell>
              <TableCell>Vendor ID</TableCell>
              <TableCell>Vendor Name</TableCell>
              <TableCell>Invoice Ref</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Invoice Date</TableCell>
              <TableCell>Document Type</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {(displayData.length > 0 &&
              displayData.map((item, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell>
                      <Button
                        variant='text'
                        color='primary'
                        onClick={() => handleJSON(item)}
                      >
                        {item['GRN/SRN Number']}
                      </Button>
                    </TableCell>
                    <TableCell>{item['Linked PO']}</TableCell>
                    <TableCell>{item['Sender ID']}</TableCell>
                    <TableCell>{item['Sender Name']}</TableCell>
                    <TableCell>{item['Invoice Ref']}</TableCell>
                    <TableCell>{item['Status']}</TableCell>
                    <TableCell>
                      {moment(item['Invoice Date']).format('DD/MM/YYYY')}
                    </TableCell>
                    <TableCell>{item['Document Type']}</TableCell>
                  </TableRow>
                )
              })) || (
                <TableRow>
                  <TableCell colSpan={6} sx={{ p: 5 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%'
                      }}
                    >
                      <Alert severity='error' variant='outlined'>
                        No matching records found. Please adjust your search criteria.
                      </Alert>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
    </> : null}

    {error ? <div className='center-screen'>{errorMessage}</div> : null}
  </>
}